module.exports = __webpack_public_path__ + "img/arrow-down-right.ca95a885.svg";